import { render, staticRenderFns } from "./department.vue?vue&type=template&id=8f0d94a8&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=8f0d94a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0d94a8",
  null
  
)

export default component.exports